import { CheckboxWrapper } from '@design-system';
import { useTranslation } from 'next-i18next';

import { FrameOptionConsolidated } from '../../../../types/Products';
import { CurrencyCode } from '../types';
import { getStylePrice } from '../utils/framePricing';
import { FrameStyleOption } from './FrameStyleOption';

export interface FrameStylePickerProps {
  groupName: string;
  onSelect: (styleTitle: string) => void;
  options: FrameOptionConsolidated[];
  selectedTitle: string | null;
  currencyCode?: CurrencyCode;
  isFloat?: boolean;
}

export const FrameStylePicker = ({
  currencyCode,
  groupName,
  isFloat = false,
  onSelect,
  options,
  selectedTitle,
}: FrameStylePickerProps) => {
  const { t } = useTranslation('checkout');
  const selectedOption = options.find(({ title }) => title === selectedTitle);
  const selectedPrice = getStylePrice(selectedOption ?? null);

  return (
    <fieldset className="grid gap-3">
      <div className="grid">
        <legend className="font-bold">{t('framing.frameStyle')}</legend>
        <p className="text-neutral-4">{t('framing.frameStyleSubtitle')}</p>
      </div>

      <CheckboxWrapper>
        {options.map((option) => (
          <FrameStyleOption
            key={option.title}
            checked={option.title === selectedTitle}
            currencyCode={currencyCode}
            isFloat={isFloat}
            description={option.description}
            groupName={groupName}
            images={option.images}
            onSelect={() => onSelect(option.title)}
            priceDelta={getStylePrice(option) - selectedPrice}
            recommendedLabel={
              option.recommended ? option.recommendedLabel : undefined
            }
            title={option.title}
          />
        ))}
      </CheckboxWrapper>
    </fieldset>
  );
};
